import { apiFetch } from "@/lib/api";

interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

/** GET whether an e-filing connector token is configured for the firm. */
export async function getConnectorTokenStatus(): Promise<boolean> {
  const body = await apiFetch<Envelope<{ configured: boolean }>>(
    "/efiling/connector/token/",
  );
  return body.data.configured;
}

/** POST mint / rotate the connector token. The raw token is returned once. */
export async function mintConnectorToken(): Promise<string> {
  const body = await apiFetch<Envelope<{ token: string }>>(
    "/efiling/connector/token/",
    { method: "POST", json: {} },
  );
  return body.data.token;
}
